/** @format */

import moment from "moment";
import service from "./service";
import { api_key, STORAGE_API } from "./common";
import { REGIONS } from "../components/syndication/constants/constants";
import { BUSINESS_UNIT } from "./PreviousSession.constants";

export function authHeader() {
  // return authorization header with jwt token
  let user = JSON.parse(localStorage.getItem("okta-token-storage"));

  if (user && user.accessToken.accessToken) {
    return { Authorization: `Bearer ${user.accessToken.accessToken}` };
  } else {
    return null;
  }
}

export function uploadJPEG(blob, section, filename) {
  let renamedFile = new window.File([blob], filename, {
    type: "image/jpeg",
    lastModified: Date.now(),
  });
  return uploadImages(renamedFile, section);
}

export function fileUpload1(blob, section, filename) {
  let renamedFile = new window.File([blob], filename, {
    type: "image/png",
    lastModified: Date.now(),
  });
  return uploadImages(renamedFile, section);
}

export function fileUpload(file, section, uploadProgressCallback = () => {}) {
  // let files = e.target.files || e.dataTransfer.files;
  // if (!files.length) {
  //   return;
  // }
  if (section.title === "Advertisement" && file.name.split(".").pop() === "gif") {
    // let file = files[0];
    let renamedFile = new window.File([file], generateFileName(file, section), {
      type: "image/gif",
      lastModified: Date.now(),
    });
    return uploadImages(renamedFile, section, uploadProgressCallback);
  } else {
    // let file = files[0];
    let renamedFile = new window.File([file], generateFileName(file, section), {
      type: "image/png",
      lastModified: Date.now(),
    });
    return uploadImages(renamedFile, section, uploadProgressCallback);
  }
}

export function formatDate(date = new Date(), format = "") {
  return moment(date).format(format);
}
export function getPreviousDate(date = new Date()) {
  return moment(date).subtract(1, "days");
}
export function isSelectedDateLessThanCurrentDate(selectedDate, currentDate = formatDate(undefined, "YYYY-MM-DD")) {
  return moment(selectedDate).isBefore(currentDate);
}

export function canReportBeDisabled(reportDate, reportCreatedDate, currentDate = formatDate(undefined, "YYYY-MM-DD")) {
  if (reportCreatedDate === null) return false;

  return moment(reportDate).isBefore(currentDate) && moment(reportCreatedDate).isBefore(currentDate);
}
export function getReportCreatedDate(macroMarketReport, freightCommentary) {
  return {
    macroReportDate: macroMarketReport && macroMarketReport.createdDate,
    freightReportDate: freightCommentary && freightCommentary.createdDate,
  };
}
function formatDateToImageUpload() {
  let date = new Date();
  return moment(date).format("YYYYMMDDHHMMSS");
}

export function generateFileName(file, section) {
  let fileExtenstion = file.name.split(".").pop();
  let fileName = section.title.replace(/\s/g, "");
  fileName = fileName + formatDateToImageUpload() + "." + fileExtenstion;
  return fileName;
}

export async function uploadImages(file, section, uploadProgressCallback) {
  try {
    let imagePath = await service.postImageToMiAppStorage(file, uploadProgressCallback).then((res, rej) => {
      return `${STORAGE_API}/downloadImage/${file.name}`;
    });
    return imagePath;
  } catch (err) {
    throw err;
  }
}

export function removeImage(section) {
  section.imagePath = "";
}

export function classNames(...args) {
  if (args) {
    let classes = [];

    for (let i = 0; i < args.length; i++) {
      let className = args[i];

      if (!className) continue;

      const type = typeof className;

      if (type === "string" || type === "number") {
        classes.push(className);
      } else if (type === "object") {
        const _classes = Array.isArray(className)
          ? className
          : Object.entries(className).map(([key, value]) => (!!value ? key : null));

        classes = _classes.length ? classes.concat(_classes.filter((c) => !!c)) : classes;
      }
    }

    return classes.join(" ");
  }

  return null;
}
export function createApi(baseUrl, json) {
  var url = baseUrl + "?";
  for (var key in json) {
    url = url + key + "=" + json[key] + "&";
  }
  url = url.slice(0, -1);
  return url;
}

export function cocoaSymbolToMonth(symbol) {
  const arr = {
    H: "Mar",
    K: "May",
    N: "Jul",
    U: "Sep",
    Z: "Dec",
  };
  return arr[symbol];
}

export function getCocoaPercentChanges(symbols, closeDate, previousDate) {
  var promiseArr = [];
  var res = [];
  for (const sym of symbols) {
    const data = {};
    data["symbol"] = sym;
    data["apikey"] = api_key;
    data["type"] = "dailyNearest";
    data["endDate"] = moment(closeDate).format("YYYY-MM-DD");
    data["startDate"] = moment(previousDate).format("YYYY-MM-DD");
    promiseArr.push(service.getPricedata(data, ""));
  }
  return Promise.all(promiseArr).then((values) => {
    for (var i = 0; i < values.length; i++) {
      const vals = values[i].results;
      const curr_val = vals[vals.length - 1];
      var percentChange = ((curr_val.close - vals[0].close) / vals[0].close) * 100;
      percentChange = Math.round(percentChange * 100) / 100;
      curr_val.percentChange = percentChange;
      res.push(curr_val);
    }
    return res;
  });
}

getTextFromHtml.parser = null;
export function getTextFromHtml(htmlContent) {
  if (getTextFromHtml.parser === null) {
    getTextFromHtml.parser = new DOMParser();
  }
  const tempEle = getTextFromHtml.parser.parseFromString(htmlContent, "text/html");
  return tempEle.body.innerText || tempEle.body.textContent;
}

export const getRowsPerPage = (data, ROWS_PER_PAGE_CONST) => {
  const limit = Math.ceil(data.length / ROWS_PER_PAGE_CONST);
  return Array(limit)
    .fill("")
    .map((v, i) => (i + 1) * ROWS_PER_PAGE_CONST);
};

export const dataUrItoBlob = (dataUri) => {
  var binary = atob(dataUri.split(",")[1]);
  var mimeString = dataUri.split(",")[0].split(":")[1].split(";")[0];
  var array = [];
  for (var i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], { type: mimeString });
};

export const getMonth = (item) => {
  if (item.symbol.startsWith("^")) {
    return "SPOT";
  } else if (item.symbol.startsWith("C3:")) {
    return item.commodityDataDelivery;
  } else {
    return item.month.substr(0, 3) + item.symbol.substr(item.symbol.length - 2, 2);
  }
};

export const getPrice = (item, region) => {
  const closeSymbols = ["^EURUSD", "^MYRUSD"];
  const threeDecimal = ["^EURUSD", "^GBPUSD", "^USDBRL", "^USDARS"];
  const twoDecimal = ["ZSQ24", "ZLQ24", "ZMQ24", "XRQ24", "RSX24", "CBN24", "LFM24"];
  const roundOff = ["C3:RPO8NLM1", "C3:RPM0LRM2", "C3:SFO0WEM2", "C3:SFM8LOM2"];
  const market = item.name;

  if (twoDecimal.includes(item.symbol)) {
    const a = parseFloat(item.previousClose).toFixed(2);
    return a;
  } else if (threeDecimal.includes(item.symbol)) {
    const a = parseFloat(item.previousClose).toFixed(3);
    return a;
  } else if (roundOff.includes(item.symbol)) {
    return Math.round(item.previousClose);
  }
  // logic for setting price for MATIF Rapseeds
  else if (item.symbol.startsWith("XR") && market === "Rapeseed" && item.exchange === "MATIF") {
    return item.lastPrice;
  } else if (closeSymbols.includes(item.symbol) && region === REGIONS.EMEA) {
    if (item.symbol === "^MYRUSD") {
      return parseFloat(1 / item.previousClose).toFixed(3);
    } else {
      return item.previousSettlement !== null ? item.previousSettlement : item.previousClose;
    }
  } else {
    return item.previousClose;
  }
};

export const getCocoaPrice = (item) => {
  const threeDecimal = ["^GBPUSD", "^GBPEUR", "^USDBRL", "^USDBRL"];
  const twoDecimal = ["^USDCNY", "^USDARS", "^USDMXN"];
  if (twoDecimal.includes(item.symbol)) {
    const a = parseFloat(item.close).toFixed(2);
    return a;
  } else if (threeDecimal.includes(item.symbol)) {
    const a = parseFloat(item.close).toFixed(3);
    return a;
  }
  return item.close;
};

export const formatPriceInUS = (price = "") => {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const monthNamesSA_PG = {
  January: "janeiro",
  February: "fevereiro",
  March: "março",
  April: "abril",
  May: "maio",
  June: "junho",
  July: "julho",
  August: "agosto",
  September: "setembro",
  October: "outubro",
  November: "novembro",
  December: "dezembro",
};

const monthNamesSA_ES = {
  January: "enero",
  February: "febrero",
  March: "marzo",
  April: "abril",
  May: "mayo",
  June: "junio",
  July: "julio",
  August: "agosto",
  September: "septiembre",
  October: "octubre",
  November: "noviembre",
  December: "diciembre",
};

export const getFormattedDateForSyndication = (businessUnit, region, date) => {
  if (businessUnit === BUSINESS_UNIT.COCOA) {
    if (region === REGIONS.SA_PG) {
      const month = moment(date).format("MMMM");
      return `${monthNamesSA_PG[month]} ${moment(date).format("D, YYYY")}`;
    } else if (region === REGIONS.SA_ES) {
      const month = moment(date).format("MMMM");
      return `${monthNamesSA_ES[month]} ${moment(date).format("D, YYYY")}`;
    }
  }

  return moment(date).format("MMMM D, YYYY");
};

export const isString = (str) => typeof str === "string";
